import { useRef, useState, useEffect, useCallback, useMemo } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/footer";
import PhoneContainer from "./components/phone_container";
import Modal from "./components/forms/form";

function App(onOrderClick) {
  const SoftRoofRef = useRef(null);
  const ToughRoof = useRef(null);
  const BalconyRoof = useRef(null);
  const leakRoofRef = useRef(null);
  const drainageRef = useRef(null);
  const additionalRef = useRef(null);
  const footerRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const [forceLoadedSections, setForceLoadedSections] = useState([]); // Секции для принудительной загрузки

  const navItems = useMemo(
    () => [
      { id: "soft-roof", name: "М’яка покрівля", ref: SoftRoofRef },
      { id: "tough-roof", name: "Жорстка покрівля", ref: ToughRoof },
      {
        id: "leak-roof",
        name: "Ремонт і усунення протікань",
        ref: leakRoofRef,
      },
      { id: "drainage-roof", name: "Водостічні системи", ref: drainageRef },
      {
        id: "additional-services",
        name: "Додаткові послуги",
        ref: additionalRef,
      },
      { id: "contacts", name: "Контакти", ref: footerRef },
    ],
    [SoftRoofRef, ToughRoof, leakRoofRef, drainageRef, additionalRef, footerRef]
  );

  const scrollToRef = (ref, index) => {
    if (ref.current) {
      const headerOffset = 100; // Измените, если нужно скорректировать отступ
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      // Загружаем секции до текущей
      const sectionsToLoad = navItems
        .slice(0, index + 1)
        .map((item) => item.name);
      setForceLoadedSections(sectionsToLoad);

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth", // Обеспечивает плавную прокрутку
      });
    }
  };

  const handleScroll = useCallback(() => {
    navItems.forEach((item, index) => {
      const section = item.ref.current;
      if (section) {
        const rect = section.getBoundingClientRect();
        const headerOffset = 300;
        if (rect.top <= headerOffset && rect.bottom >= headerOffset) {
          setActiveIndex(index);
          console.log("Active section:", index, item.name); // Проверяем, изменяется ли активный индекс
        }
      }
    });
  }, [navItems]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <div className="app">
      <PhoneContainer />
      <Header
        navItems={navItems}
        scrollToRef={scrollToRef}
        activeIndex={activeIndex}
        onOrderClick={() => setIsModalOpen(true)}
      />
      <Main
        softRoofRef={SoftRoofRef}
        toughRoof={ToughRoof}
        balconyRoof={BalconyRoof}
        fscrol
        leakRoofRef={leakRoofRef}
        drainageRef={drainageRef}
        additionalRef={additionalRef}
        forceLoadedSections={forceLoadedSections} // Передаем секции для принудительной загрузки
        onOrderClick={() => setIsModalOpen(true)}
      />
      <Footer ref={footerRef} id="contacts" />
      {isModalOpen && <Modal onClose={handleCloseModal} />}
    </div>
  );
}

export default App;
